import React from "react";

import MessageModal from "../../../../components/HexModal/MessageModal";
import { getLabel } from "../../../../hooks/use-labels";

import "./style.css";
import { getConfig } from "../../../../hooks/use-config";


const UniqueProductModal = ({ onClose }) => {
  const MAX_UNIQUE_PRODUCT = +getConfig("maxUniqueCartItems");
  const uniqueProductError = getLabel("uniqueProductError");
  return (
    <MessageModal
      open={true}
      title={getLabel("cartLimitLabel")}
      text={uniqueProductError.replace("{{}}", MAX_UNIQUE_PRODUCT)}
      onOkay={onClose}
      className={"cart-limit-modal"}
    />
  );
};

export default UniqueProductModal;
